import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from '@emotion/styled';
import { Global, css } from '@emotion/react';
import pluralize from 'pluralize';
import { withRouter } from 'react-router-dom';
import ImageUploader from 'ui_system/forms/ImageUploader';
import { Grid } from 'views/anyguide/messages/styles';
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from 'react-sortable-hoc';

import ReactSpinner from 'react-spinjs-fix';

import { DEFAULT_OPTS as SPINNER_OPTIONS } from 'views/anyguide/helpers/spinner';

import RemoveIcon from 'views/ui/icons/remove-icon';
import ReorderIcon from 'views/ui/icons/reorder-icon';
import { Theme } from 'ui_system/theme';

import {
  FormContainer,
  SubmitButton,
  Actions,
} from 'ui_system/forms/FormStyles';

import { updateTourStepForm } from 'data_system/resource_portal/actions/experienceActions';

import { t } from 'services/translation';

const Photo = styled('div')`
  width: 160px;
  height: 160px;
  border-top: solid 10px white;
  border-right: solid 10px white;
  border-bottom: solid 10px white;
  position: relative;
  display: inline-block;
  cursor: move;
  background-color: #999;
  box-sizing: border-box;
  &:hover {
    svg {
      opacity: 1;
    }
  }
  svg {
    position: absolute;
    right: -9px;
    top: -9px;
    opacity: 0;
    transition: opacity 200ms linear;
    z-index: 1;
    cursor: pointer;
  }
  .spinner {
    z-index: 1000;
  }
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    border: solid 5px white;
    width: 33.33%;
    height: calc(33.33vw - 20px);
  }
`;

const RemoveButton = styled(RemoveIcon)``;
const ReorderButton = styled(ReorderIcon)`
  fill: #aaa;
  height: 12px;
  margin-left: 10px;
`;

const Image = styled('img')`
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 0;
`;

const CoverPhoto = styled('div')`
  color: #fff;
  background-color: #000;
  padding: 4px 8px;
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 12px;
  border-radius: 8px;
  letter-spacing: 0.25px;
  z-index: 20;
`;

const Info = styled('div')`
  color: #bbb;
  text-align: center;
  font-size: 16px;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    font-size: 1.5rem;
  }
`;

const PhotoCount = styled('div')`
  text-align: right;
`;

const ListContainer = styled('ul')`
  border-top: solid 1px #ccc;
  padding-top: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  display: block;
  position: relative;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    padding-top: 10px;
    margin-bottom: 10px;
  }
`;

const ImagesHeader = styled(Grid)`
  color: #bbb;
  font-size: 16px;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    font-size: 1.5rem;
  }
`;

const DragText = styled('div')``;

const ImageUploads = styled('div')`
  text-align: center;
  margin-top: 5px;
`;

const DoneButton = styled(SubmitButton)`
  background-color: ${(props) =>
    props.brandColor ? props.brandColor : Theme.colors.green};
`;

// Form content
class PhotosForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      imagesAdding: 0,
    };
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (
      nextProps.imagesUploading !== this.props.imagesUploading &&
      nextProps.imagesUploading === 0
    ) {
      this.setState({
        imagesAdding: 0,
      });
    }
  };

  UNSAFE_componentWillMount() {
    const { updateTourStepForm } = this.props;
    updateTourStepForm(null);
  }

  uploadImage = (images) => {
    const { experience, onSubmit } = this.props;
    const ImagesPayload = { experienceId: experience.id, images };
    onSubmit(ImagesPayload);
  };

  onSortEnd = ({ oldIndex, newIndex }, e) => {
    const { images, handleMoveImage } = this.props;
    const image = images[oldIndex];
    handleMoveImage(image.id, oldIndex, newIndex);
  };

  handleDoneClick = () => {
    const { history } = this.props;
    history.push('/experiences');
  };

  uploadStarted = () => {
    this.setState({
      imagesAdding: (this.state.imagesAdding += 1),
    });
  };

  renderUploadingPlaceholders() {
    // const { imagesUploading } = this.props;
    const { imagesAdding } = this.state;
    const images = [];
    for (let i = 0; i < imagesAdding; i++) {
      images.push(
        <Photo key={`image-loading-${i}`}>
          <Image />
          <ReactSpinner config={SPINNER_OPTIONS} />
        </Photo>
      );
    }

    return <span>{images}</span>;
  }

  render() {
    const { images, allStepsDone, brand, allStepsCompleted, i18n } = this.props;
    const { linkColor } = brand;

    const SortableItem = SortableElement(({ image, sortIndex }) => {
      const { handleRemoveImage } = this.props;
      const DragHandle = SortableHandle(() => (
        <Image src={image.squarePhoto} />
      ));
      return (
        <Photo key={image.id}>
          <DragHandle />
          {image.removing && <ReactSpinner config={SPINNER_OPTIONS} />}
          {sortIndex !== 0 && (
            <RemoveButton onClick={() => handleRemoveImage(image.id)} />
          )}
          {sortIndex === 0 && <CoverPhoto>{t('COVER_PHOTO')}</CoverPhoto>}
        </Photo>
      );
    });

    const SortableList = SortableContainer(({ children }) => {
      return <ListContainer>{children}</ListContainer>;
    });
    return (
      <>
        <Global
          styles={css`
            .sortableHelper {
              z-index: 100000000;
            }
          `}
        />
        <FormContainer>
          <ImageUploads>
            <ImageUploader
              uploadStarted={this.uploadStarted}
              name="image"
              imageUrl=""
              onUpload={this.uploadImage}
              buttonColor={linkColor}
              i18n={i18n}
            />
          </ImageUploads>
          {images.length > 0 && (
            <ImagesHeader gridTemplateColumns="75% 25%">
              <DragText>
                {t('DRAG_AND_DROP_TO_REORDER')}
                <ReorderButton />
              </DragText>
              <PhotoCount>
                {images.length} {pluralize('photo', images.length)}
              </PhotoCount>
            </ImagesHeader>
          )}
          <SortableList
            helperClass="sortableHelper"
            hideSortableGhost={false}
            onSortStart={this.onSortStart}
            onSortEnd={this.onSortEnd}
            axis="xy"
            useDragHandle
            // pressDelay={100}
          >
            {images.map((value, index) => (
              <SortableItem
                key={`item-${index}`}
                index={index}
                sortIndex={index}
                image={value}
                remove={this.handleClickRemove}
              />
            ))}
            {this.renderUploadingPlaceholders()}
          </SortableList>
          {allStepsCompleted ? (
            <Actions border>
              <DoneButton
                brandColor={linkColor}
                justify="center"
                onClick={this.handleDoneClick}
              >
                {t('DONE')}
              </DoneButton>
            </Actions>
          ) : (
            <Info>
              {t('THE_FIRST_IMAGE_WILL_BE_USED_AS_YOUR_COVER_PHOTO')} <br />
              {t('LANDSCAPE_IMAGES_WORK_BEST')}
            </Info>
          )}
        </FormContainer>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { experienceReducer, initialProps } = state;

  return {
    tourUpdating: experienceReducer.experienceUpdating,
    experience: experienceReducer.experience,
    images: experienceReducer.images,
    brand: initialProps.brand,
    allStepsCompleted: experienceReducer.allStepsCompleted,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ updateTourStepForm }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PhotosForm));
